import _asyncToGenerator from "@babel/runtime-corejs3/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime-corejs3/regenerator";
import { useEffect } from "react";
import { useAuthInternal } from "./AuthContext";
export var SilentCallback = function () {
  var oidc = useAuthInternal().oidc;
  return useEffect(function () {
    var _ref,
      playCallbackAsync = (_ref = _asyncToGenerator(_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function (_context) {
          for (;;) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", oidc.silentLoginCallbackAsync());
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      })), function () {
        return _ref.apply(this, arguments);
      });
    playCallbackAsync();
  }, [oidc]), null;
};